/**
 * Created by jcorrea on 20/02/18.
 */
angular
	.module('servicepro.analysis.hours', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);
